import React, { Component } from "react";
import { Doughnut } from "react-chartjs-2";

class DoughnutTemplate extends Component {
	constructor(props) {
		super(props);
		this.state = {
			labels: [],
			data: []
		};
	}

	componentDidMount() {
		let labels = [];
		let data = [];

		for (let i = 0; i < this.props.data.length; i++) {
			labels.push(this.props.data[i]["label"]);
			data.push(this.props.data[i]["value"]);
		}

		this.setState({
			labels,
			data
		});
	}

	componentDidUpdate(prevProps, prevState) {
		let labels = [];
		let data = [];

		for (let i = 0; i < this.props.data.length; i++) {
			labels.push(this.props.data[i]["label"]);
			data.push(this.props.data[i]["value"]);
		}

		if (prevProps.data !== this.props.data) {
			this.setState({
				labels,
				data
			});
		}
	}

	render() {
		const data = {
			labels: this.state.labels,
			datasets: [
				{
					data: this.state.data,
					backgroundColor: [
						"#3B5A87",
						"#6184A7",
						"#18BACB",
						"#333333",
						"#222222",
						"#A5A5A5",
						"#6184A7",
						"#592C2D",
						"#6E9081",
						"#322D42",
						"#B2D1DE"
					],
					hoverBackgroundColor: [
						"#3B5A87",
						"#6184A7",
						"#18BACB",
						"#333333",
						"#222222",
						"#A5A5A5",
						"#6184A7",
						"#592C2D",
						"#6E9081",
						"#322D42",
						"#B2D1DE"
					]
				}
			]
		};

		const legend = {
			display: true,
			position: "left",
			labels: {
				fontColor: "rgb(255, 255, 255)"
			}
		};

		return (
			<div>
				<Doughnut data={data} legend={legend} />
			</div>
		);
	}
}

export default DoughnutTemplate;



// WEBPACK FOOTER //
// ./src/components/pages/Analytics/DoughnutTemplate.js